import React from 'react';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExcelComponent = ({ data, titulo, headersColumn })=>{

    const ColumnasExcel = headersColumn.filter(value=> value.show).filter(value=> value.type !== 'image' && value.type !== 'action').map((value, index)=>{
            return(<ExcelColumn label={value.label} value={value.id} key={`fila${index}`}/>) 
    });

    return(
        <ExcelFile  filename="database.xlsx" element={titulo}>
            <ExcelSheet data={data} name="database">
                { ColumnasExcel }
            </ExcelSheet>
        </ExcelFile >
    )
};

export default ExcelComponent